const heyuiConfig = () => {
  HeyUI.config('menu', {
    keyName: 'key',
    titleName: 'title',
    childrenName: 'children'
  });
  HeyUI.config('datepicker', {
    startWeek: 7
  });
};

export default heyuiConfig;
